<template>
  <v-container class="admin-promotion">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_hkiarace.promotion') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addPromotionModalShown = true">
          {{ $t('admin_promotion.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <PromotionList full-height
                       :refresh-trigger.sync="refreshTrigger"
                       @edit="onPromotionEdit"></PromotionList>
      </v-col>
    </v-row>

    <AddPromotionModal :shown="addPromotionModalShown"
                       @cancel="addPromotionModalShown = false"
                       @finish="onAddPromotionModalFinish"></AddPromotionModal>

    <EditPromotionModal :shown="editPromotionModalShown"
                        :promotion-id="editingPromotionId"
                        @cancel="onEditPromotionModalFinish"
                        @finish="onEditPromotionModalFinish"></EditPromotionModal>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import PromotionList from "@/components/promotion/PromotionList";
import AddPromotionModal from "@/components/promotion/AddPromotionModal";
import EditPromotionModal from "@/components/promotion/EditPromotionModal";

export default {
  name: 'Promotion',
  components: {EditPromotionModal, AddPromotionModal, PromotionList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addPromotionModalShown = ref(false);
    const onAddPromotionModalFinish = function (item) {
      addPromotionModalShown.value = false;
      refresh();
      onPromotionEdit(item);
    }

    const editingPromotionId = ref(null);
    const editPromotionModalShown = ref(false);
    const onPromotionEdit = function (item) {
      editingPromotionId.value = item.id;
      editPromotionModalShown.value = true;
    };
    const onEditPromotionModalFinish = function () {
      editPromotionModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      addPromotionModalShown,
      onAddPromotionModalFinish,

      editingPromotionId,
      editPromotionModalShown,
      onPromotionEdit,
      onEditPromotionModalFinish,
    }
  }
}
</script>

<style lang="less">
.admin-promotion {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
